export default __webpack_public_path__ + "static/Nosso-proposito-e1f2a28f1ed3571725755dac3ec31cf5.jpg";